import axios from 'axios';

const API_BASE = (location.host == '127.0.0.1:8080' || location.host == 'localhost:8080')
    ? 'http://amaken.test/api/'
    : 'https://admin.amakenapp.com/api/';

// Maps a route's public name to the addon code required to access it on Freemium.
// Routes absent from this map (e.g. 'contact') have no addon requirement.
export const ADDON_REQUIREMENTS = {
    reservation: 'online-reservations',
    reviews: 'review-rating',
};

export const LOCK_MESSAGE = 'This feature is available only for Amaken Pro restaurants or restaurants that have purchased the required addon.';
export const NOT_CONFIGURED_MESSAGE = 'This feature is not available because widget customization has not been configured yet.';

// One in-flight/resolved lookup per slug per page load — avoids refetching on every nav within the same restaurant.
const accessCache = new Map();

function fetchPlaceAccess(slug) {
    if (accessCache.has(slug)) {
        return accessCache.get(slug);
    }
    const promise = axios.get(API_BASE + 'addon/public-access', { params: { slug } })
        .then(response => response.data?.data || { is_pro: false, addons: {} })
        .catch(() => ({ is_pro: false, addons: {} }));
    accessCache.set(slug, promise);
    return promise;
}

/**
 * Central, reusable route-access check.
 * Step 1: Pro plan always passes.
 * Step 2: Freemium must have purchased the addon required by `to.meta.addonRequired` (if any).
 * Routes with no `addonRequired` meta (e.g. contact) always pass this check.
 */
export async function checkRouteAddonAccess(to) {
    const requiredAddon = to.meta?.addonRequired;
    const slug = to.params?.slug;

    if (!requiredAddon || !slug) {
        return { allowed: true };
    }

    const access = await fetchPlaceAccess(slug);

    if (access.is_pro || access.addons?.[requiredAddon]) {
        return { allowed: true };
    }

    return { allowed: false, message: LOCK_MESSAGE };
}
